import SummarySection from "features/bots/BotForm/Summaries/SummarySection";
import React, { useContext } from "react";
import BotSummary from "features/bots/BotForm/Summaries/BotSummary";
import { BotFormContext } from "@shared/features/bots/BotForm/common/BotForm.context";
import { BotData } from "@shared/types";
import { BotFormType } from "@shared/features/bots/BotForm/common/types";
import { DrawerContext } from "common/Drawers/Drawer.context.ts";
import Text from "common/Typography/Text";

interface BulkEditAccountsSummaryProps {
  isValid?: boolean;
  onBotClick: (bot: BotData) => void;
}

const BotsSummary = ({ isValid, onBotClick }: BulkEditAccountsSummaryProps) => {
  const { bulkActionValidBotsData, bulkActionInvalidBotsData, botFormType } =
    useContext(BotFormContext)!;
  const { isDrawer } = useContext(DrawerContext) || {};

  const isBulkEdit = botFormType === BotFormType.BULK_EDIT;
  const sectionBots = isValid
    ? bulkActionValidBotsData
    : bulkActionInvalidBotsData;
  const validText = isValid ? "Valid" : "Invalid";

  const getContent = () => {
    if (!sectionBots?.length) {
      return (
        <Text
          type="secondary"
          style={{ textAlign: "center", padding: "8px 0 4px" }}
        >
          There are no {validText.toLowerCase()} bots
        </Text>
      );
    }
    return sectionBots?.map((bot, index) => {
      return (
        <BotSummary
          key={index}
          index={index}
          bot={bot}
          isValid={isValid}
          onClick={onBotClick}
        />
      );
    });
  };

  return (
    <SummarySection
      columnNames={[isBulkEdit ? "Bot Name" : "Account"]}
      columnSpans={[24]}
      title={`${validText} Bots`}
      isCard={!isDrawer}
      containerStyle={isDrawer ? { padding: 0 } : undefined}
    >
      {getContent()}
    </SummarySection>
  );
};

export default BotsSummary;
